import { render, staticRenderFns } from "./HerbariumLists.vue?vue&type=template&id=a517beec&scoped=true&"
import script from "./HerbariumLists.vue?vue&type=script&lang=js&"
export * from "./HerbariumLists.vue?vue&type=script&lang=js&"
import style0 from "./HerbariumLists.vue?vue&type=style&index=0&id=a517beec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a517beec",
  null
  
)

export default component.exports